import React from "react";
import { 
	RCCGrid,
	RCCInput,
	RCCCheckBox
} from "react-common-components";
import DateTimePickerRange from "src/components/DateTimePickerRange";
import LovKanban from "src/components/Lov/Kanban";
import LovUsers from "src/components/Lov/Users";
import Title from "src/components/Title";
import { useAuth } from "src/context/Auth/context";
import { useTranslation } from "src/context/Translations/context";
import { IKanbanType } from "src/pages/Actions/Kanban/kanbanModes/MultipleKanbans/interface";
import Phases from "../Phases";

import { IFormSimplifiedFields } from "./interface";

const FormSimplifiedFields: React.FC<IFormSimplifiedFields> = ({
	projectSelected,
	isDisabled,
	modelAgile,
	control,
	errors,
	register,
	unregister,
	setValue,
	clearErrors,
	controlHours
}) => {
	const { translate } = useTranslation();
	const { user } = useAuth();

	return(
		<>
			<RCCGrid
				container
				item
				xs={12}
				sm={10}
				md={8}
				lg={8}
			>
			</RCCGrid>
			<RCCGrid 
				styleInline="display: none"
			>
				<RCCInput 
					register={register}
					name="pra002Id"
					label=""
					defaultValue={projectSelected?.pra002Id || 0}
					readOnly
				/>
			</RCCGrid>
			<RCCGrid
				container
				item
				xs={12}
				sm={10}
				md={8}
				lg={8}
			>
				<RCCInput 
					register={register}
					name="pra002Titulo"
					label={translate("Título")}
					maxLength={200}
					defaultValue={projectSelected?.pra002Titulo}
					error={errors.pra002Titulo}
					required
				/>
			</RCCGrid>
			<RCCGrid
				container
				item
				xs={12}
				sm={10}
				md={8}
				lg={8}
				alignItems="flex-end"
			>
				<div style={{display: "flex", flex: 1}}>
					<DateTimePickerRange
						control={control}
						type="datePicker"
						label={translate("Data Estimada")}
						labelSeparator={translate("Até")}
						nameInit="pra002Dtiniest"
						nameEnd="pra002Dtfimest"
						defaultValueInit={projectSelected?.pra002Dtiniest ? projectSelected?.pra002Dtiniest : new Date()}
						defaultValueEnd={projectSelected?.pra002Dtfimest ? projectSelected?.pra002Dtfimest : new Date()}
						error={errors.pra002Dtiniest || errors.pra002Dtfimest}
						required
					/>
				</div>
			</RCCGrid>
			<RCCGrid
				container
				item
				xs={12}
				sm={10}
				md={8}
				lg={8}
				alignItems="flex-end"
			>
				<LovKanban
					control={control}
					name="pra002Kba001Id"
					label={translate("Kanban")}
					defaultValue={projectSelected?.pra002Kba001Id ? String(projectSelected?.pra002Kba001Id) : undefined}
					isClearable
					isCreatable
					error={errors.pra002Kba001Id}
					extraParametersOnCreate={{
						type: IKanbanType.PROJECT
					}}
					extraParametersOnLoad={{
						type: IKanbanType.PROJECT
					}}
				/> 
			</RCCGrid>
			<hr />
			<RCCGrid
				container
				item
				xs={12}
				sm={10}
				md={8}
				lg={8}
			>
				<Title 
					color="purple"
					marginBottom={15}
				>
					{translate("RACI")}
				</Title>
			</RCCGrid>
			<RCCGrid
				container
				item
				xs={12}
				sm={10}
				md={8}
				lg={8}
				alignItems="flex-end"
			>
				<RCCGrid
					container
					item
					xs={12}
					sm={6}
				>
					<LovUsers 
						control={control}
						name="pra002Efa005Id"
						label={translate("Responsável")}
						defaultValue={ projectSelected.pra002Efa005Id ? projectSelected.pra002Efa005Id?.toString() : `${user.efa005Id}`}
						error={errors.pra002Efa005Id}
						required
						disabled={isDisabled}
					/>
				</RCCGrid>
				<RCCGrid
					container
					item
					xs={12}
					sm={5}
				>
					<RCCCheckBox 
						name="pra002Notificaresponsavel"
						defaultChecked={projectSelected.pra002Notificaresponsavel !== "N"}
						label={translate("Acompanhar andamento")}
						labelPosition="end"
						register={register}
						styleInline={{checkbox: "padding-left: 5%;"}}
						error={errors.pra002Notificaresponsavel}
						disabled={isDisabled}
					/>
				</RCCGrid>
			</RCCGrid>
			<RCCGrid
				container
				item
				xs={12}
				sm={10}
				md={8}
				lg={8}
				alignItems="flex-end"
			>
				<RCCGrid
					container
					item
					xs={12}
					sm={6}
				>
					<LovUsers 
						control={control}
						name="pra002Efa005Id2"
						label={translate("Autoridade")}
						defaultValue={projectSelected.pra002Efa005Id2 ? projectSelected.pra002Efa005Id2?.toString() : `${user.efa005Id}`}
						error={errors.pra002Efa005Id2}
						required
						disabled={isDisabled}
					/>
				</RCCGrid>
				<RCCGrid
					container
					item
					xs={12}
					sm={5}
				>
					<RCCCheckBox 
						name="pra002Notificaautoridade"
						defaultChecked={projectSelected.pra002Notificaautoridade !== "N"}
						label={translate("Acompanhar andamento")}
						labelPosition="end"
						register={register}
						styleInline={{checkbox: "padding-left: 5%;"}}
						error={errors.pra002Notificaautoridade}
						disabled={isDisabled}
					/>
				</RCCGrid>
			</RCCGrid>
			{
				!modelAgile &&
				<>
					<hr />
					<RCCGrid
						container
						item
						xs={12}
						sm={10}
						md={8}
						lg={8}
					>
						<Title 
							color="purple"
							marginBottom={15}
						>
							{translate("Fases")}
						</Title>
					</RCCGrid>
					<RCCGrid
						container
						item
					>
						<Phases
							isDisabled={false}
							isCopy={false}
							control={control}
							error={errors}
							register={register}
							unregister={unregister}
							clearErrors={clearErrors}
							setValue={setValue}
							controlHours={controlHours}
							phasesDefaultValue={projectSelected?.prtba003 || []}
						/>
					</RCCGrid>
				</>
			}
			
		</>
	);};

export default FormSimplifiedFields;
